import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteBoardArguments {
  params: OpalApiRequestParams<'DeleteBoardV3'>
}

// The Board Delete endpoint does not return data,
// only a response with a `204` status code. Because
// of that, we will hard code `null` as the response
export async function deleteBoard({
  params,
}: DeleteBoardArguments): Promise<null> {
  const url = new URL(
    `/boards/v3/${params.path.board_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
